import { schema } from 'normalizr';

export const name = 'surveyQuestions';

export const surveyQuestionSchema = new schema.Entity(name);

export const surveyQuestionsCollectionSchema = new schema.Array(
  surveyQuestionSchema,
);
